'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _InlineOverlayHeader = require('./components/InlineOverlayHeader.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_InlineOverlayHeader).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-inline-overlay/lib/components/inline-overlay-header/index.js
// module id = 1323
// module chunks = 1